module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(!_vm.loading) ? [_c('div', {
    staticClass: "row draft-status"
  }, [_c('div', {
    staticClass: "col-md-3 push-md-1 name"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.status')))]), _c('div', {
    staticClass: "col-md-7 push-md-1 value"
  }, [_vm._v(_vm._s(_vm.$t('pos.proposal.finalized')))])]), _c('div', {
    staticClass: "row campaign-code"
  }, [_c('div', {
    staticClass: "col-md-3 push-md-1 name"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.code')))]), _c('div', {
    staticClass: "col-md-7 push-md-1 value"
  }, [_vm._v(_vm._s(_vm.campaign.famCampaign ? _vm.campaign.famCampaign.code : '') + "\n "), _c('icon', {
    staticClass: "copy-code",
    attrs: {
      "name": _vm.copySuccess ? "check" : "copy",
      "scale": "1"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copyCampaignCode($event)
      }
    }
  })], 1)]), (_vm.campaign.famCampaign && _vm.campaign.famCampaign.clone_for_draft_id) ? _c('div', {
    staticClass: "row campaign-code"
  }, [_c('div', {
    staticClass: "col-md-3 push-md-1 name"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.cloneFor')))]), _c('div', {
    staticClass: "col-md-7 push-md-1 value"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToProposal(_vm.campaign.famCampaign.clone_for_draft_id)
      }
    }
  }, [_vm._v(_vm._s(_vm.campaign.famCampaign.clone_for))])])]) : _vm._e(), (_vm.campaign.famCampaign && _vm.campaign.famCampaign.clone_of_draft_id) ? _c('div', {
    staticClass: "row campaign-code"
  }, [_c('div', {
    staticClass: "col-md-3 push-md-1 name"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.cloneOf')))]), _c('div', {
    staticClass: "col-md-7 push-md-1 value"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToProposal(_vm.campaign.famCampaign.clone_of_draft_id)
      }
    }
  }, [_vm._v(_vm._s(_vm.campaign.famCampaign.clone_of))])])]) : _vm._e(), _c('div', {
    staticClass: "row creator-email"
  }, [_c('div', {
    staticClass: "col-md-3 push-md-1 name"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.budget')))]), _c('div', {
    staticClass: "col-md-7 push-md-1 value"
  }, [_vm._v(_vm._s(_vm.$t('pos.checkout.price', {
    price: _vm.package.budget.budget,
    context: _vm.campaign.mode
  })))])]), _c('div', {
    staticClass: "row creator-email"
  }, [_c('div', {
    staticClass: "col-md-3 push-md-1 name"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.creator')))]), _c('div', {
    staticClass: "col-md-7 push-md-1 value"
  }, [_vm._v(_vm._s(_vm.campaign.creator ? _vm.campaign.creator.email : _vm.$store.user.email))])]), (_vm.campaign.famCampaign && _vm.campaign.famCampaign.target_change_status) ? _c('div', {
    staticClass: "row target-change-status"
  }, [_c('div', {
    staticClass: "col-md-3 push-md-1 name"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.target_change_status')))]), _c('div', {
    staticClass: "col-md-7 push-md-1 value"
  }, [_vm._v(_vm._s(_vm.$t(("terms.target_change_status." + (_vm.campaign.famCampaign.target_change_status)))))])]) : _vm._e(), (_vm.send_campaign_summary) ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "form-group mt-5",
    class: {
      "has-danger": _vm.error
    }
  }, [(_vm.success) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v(_vm._s(_vm.$t('pos.proposal.email-sent')))]) : _vm._e(), _c('form-input', {
    staticClass: "col-md-10 push-md-1 email-send",
    attrs: {
      "placeholder": _vm.$t("pos.proposal.email-placeholder"),
      "errors": _vm.$v.email,
      "type": "email"
    },
    on: {
      "input": function($event) {
        _vm.$v.email.$reset()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), (_vm.error) ? _c('small', {
    staticClass: "text-muted text-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 1), _c('b-button', {
    staticClass: "mt-2 summary-email btn-block col-md-10",
    attrs: {
      "size": "md",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.sendEmail($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.proposal.send-email')))])], 1) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8408aeac"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/send-email/SendEmail.vue
// module id = 952
// module chunks = 1